<template>
  <div :class="classes">
    <div :class="contentClasses">
      <div v-if="title || tag" class="bx-box-header">
        <h5 v-if="title" class="bx-box-title">
          <img v-if="icon" :src="icon" class="icon" />
          <span v-if="!loading" v-html="title"></span>
          <PuSkeleton
            :loading="loading"
            height="20px"
            width="100px"
          ></PuSkeleton>
        </h5>
        <bx-tag v-if="tag" :color="tagColor">{{ tag }}</bx-tag>
        <span class="spacer"></span>
        <slot name="actions"></slot>
      </div>
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "bx-box",
  props: {
    title: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    dark: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: null
    },

    tag: {
      type: String,
      default: null
    },
    tagColor: {
      type: String,
      default: null
    },
    noPadding: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes() {
      const classes = ["bx-box"];

      if (this.dark) {
        classes.push("bx-dark");
      }
      return classes;
    },
    contentClasses() {
      const classes = ["bx-box-content"];

      if (this.color) {
        classes.push(`bx-color-${this.color}`);
      }

      if (this.noPadding) {
        classes.push("no-padding");
      }

      return [classes];
    }
  }
};
</script>
